import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ErrorFallback from "components/ErrorFallback/ErrorFallback";
import useGetCampaignUpdates from "pages/campaign/hooks/useGetCampaignUpdates";
import useGetCampaignUpdate from "pages/campaign/hooks/useGetCampaignUpdate";
import { useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import CampaignUpdates from "./components/CampaignUpdates/CampaignUpdates";
import CampaignUpdatesPreview from "./components/CampaignUpdatesPreview/CampaignUpdatesPreview";
import CampaignUpdateModal from "./components/CampaignUpdateModal/CampaignUpdateModal";
const isNarrow = window.matchMedia("(max-width: 768px)").matches;
const QUERY_FIRST = isNarrow ? 6 : 12;
const stripUpdateFromUrl = () => {
    const basePath = window.location.pathname
        .replace(/\/updates\/[^/]+(\/.*)?$/, "")
        .replace(/\/$/, "");
    const { search, hash } = window.location;
    window.history.replaceState(null, "", (basePath || "/") + search + hash);
};
// Matches "/updates/:id" plus anything trailing it (e.g. "/share" or unrecognised junk), so a
// URL like "/updates/:id/somejunkhere" is still treated as a deep link to the update rather
// than falling back to the campaign page.
const urlHasUpdateSuffix = (id) => {
    const pathname = window.location.pathname.replace(/\/$/, "");
    const escapedId = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return new RegExp(`/updates/${escapedId}(/.*)?$`).test(pathname);
};
const CampaignUpdatesWrapper = ({ campaign, isPreview = false, isCommentsEnabled, onViewAllUpdates, openUpdateId, showShareOnOpen, }) => {
    const { updates, loadMore, hasNextPage, loading, error, } = useGetCampaignUpdates({
        campaignId: campaign.id,
        limit: QUERY_FIRST,
    });
    // Deep-linked update: fetch it directly so the modal opens regardless of which
    // page of the feed it lives on (it may not be in the loaded list at all).
    const deepLinkId = isPreview ? null : openUpdateId;
    const { update: deepLinkUpdate } = useGetCampaignUpdate({ id: deepLinkId });
    // Re-checked against the URL (rather than always defaulting to true) so that once the
    // update modal has been closed, remounting this wrapper (e.g. by switching tabs away and
    // back) doesn't auto-open it again.
    const [deepLinkOpen, setDeepLinkOpen] = useState(() => !!deepLinkId && urlHasUpdateSuffix(deepLinkId));
    const handleDeepLinkClose = () => {
        setDeepLinkOpen(false);
        stripUpdateFromUrl();
    };
    return (_jsx(ErrorBoundary, { fallback: _jsx(ErrorFallback, { error: error }), children: _jsxs("div", { className: "campaign-container__updates-wrapper", children: [isPreview ? (_jsx(CampaignUpdatesPreview, { updates: updates, campaign: campaign, loading: loading, onViewAllUpdates: onViewAllUpdates, isCommentsEnabled: isCommentsEnabled })) : (_jsx(CampaignUpdates, { updates: isPreview ? updates.slice(0, 3) : updates, campaign: campaign, fetchMore: loadMore, loading: loading, hasNextPage: isPreview ? false : hasNextPage, isCommentsEnabled: isCommentsEnabled })), deepLinkOpen && deepLinkUpdate && (_jsx(CampaignUpdateModal, { update: deepLinkUpdate, campaign: campaign, onClose: handleDeepLinkClose, isCommentsEnabled: isCommentsEnabled, showShareOnOpen: showShareOnOpen }))] }) }));
};
export default CampaignUpdatesWrapper;
